import { render, staticRenderFns } from "./LocationDepartment.vue?vue&type=template&id=1ba5f67b&"
import script from "./LocationDepartment.vue?vue&type=script&lang=js&"
export * from "./LocationDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports